import Button from 'components/shared/Button/Button';
import Allowed from 'components/shared/Permissions/Allowed';
import { withErrorBoundary } from 'components/shared/Error/Boundary';

const HeaderActions = ({ onAddNewRoleClick, forAdmin }) => {
  return (
    <div className="flex items-center gap-2">
      <Allowed requiredPermissions={forAdmin ? 'admin_role.create' : 'role.create'}>
        <Button
          text="New role"
          icon="add-square-mono"
          size="xs"
          variant="link"
          onClick={onAddNewRoleClick}
          textClassName="whitespace-nowrap"
        />
      </Allowed>
    </div>
  );
};

export default withErrorBoundary(HeaderActions);
